const initState = {
  isApproving: false,
  error: null,
}

export default initState
